import Phaser from 'phaser';
import DraggableSprite from './DraggableSprite';
import UIAssetKeys from '../UIAssetKeys';
import ABCyaPhaser from '@abcya/abcya_phaser';
import FontKeys from '../FontKeys';

export default class DraggableBoneName extends DraggableSprite {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} x 
   * @param {number} y 
   */
  constructor(scene, boneName, spriteName) {
    super(scene, UIAssetKeys._word_bg);
    this.name = spriteName;

    this._text = ABCyaPhaser.Text.addText(0, 0, 32, 0xd25f1c, FontKeys._asapbold, boneName, this, true);
    ABCyaPhaser.Text.resizeFontToFitWidth(this._text, this._bg.width - 4, this._bg.height);
  }
}